// Setup Actions
// These tasks are performed on page load

import config from 'utils/config';
import api from './lib/api';
import i18n from 'i18n';
import filter from 'tricks/object/filter';

// make the i18n object accessible on the console
window.i18n = i18n;

// Set Default translations
// This block can be removed When we've updated the settings page
// And migrated these configs to the /translations endpoints
{
	const data = filter({
		login_welcome_message: config.loginWelcomeMessage,
		hub_title: config.pageTitle,
		login_help_message: config.loginHelpMessage,
		navbar_contact: Object(config.customContactForm).title,
	});

	// Extend resource bundle... and overwrite
	i18n.addResourceBundle('en-GB', 'translation', data, true, true);
}

/**
 * i18nInitCallback
 * @returns {Promise<void>}
 */
async function i18nCallback() {
	// Request the endpoint with the translations...
	const data = await api('cache', '/api/translations', {
		locale: i18n.language,
	});

	if (data && Object.keys(data).length) {
		// Append them to the translations service...
		i18n.addResourceBundle(i18n.language, 'translation', data, true, true);
	}
}

// Check i18n is initialized or not...
if (i18n.isInitialized) {
	i18nCallback();
} else {
	// Await the i18n init event
	i18n.on('initialized', i18nCallback);
}
